/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DocsDestroyRequest = {} | null | undefined;
export type DocsDestroyResponse = any;

export type DocsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/docs/{id}/
 *
 * ```yaml
 * operationId: docs_destroy
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const docsDestroyOperation = ({ id, ...rest }: DocsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/docs/{id}/' };
  };

/**
 * DELETE /dmx-server/docs/{id}/
 *
 * ```yaml
 * operationId: docs_destroy
 * description: >-
 *   You can order docs using GET param ordering_state
 *
 *   example:
 *
 *   http://localhost/dmx-server/docs_reduced/?ordering_state=CANCELED,SUBMITTED,REJECTED,ACCEPTED
 *
 *   At first all CANCELED docs, then all with state SUBMITTED, then REJECTED, etc.
 * tags:
 *   - docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const docsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DocsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = docsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
